  function  socialShare() {
      /**
       * Find the elements that have the component
       */
      document.querySelectorAll('[data-component="share-social"]').forEach((component) => {
          let parameters = { media: component.getAttribute('data-media'), url: component.getAttribute('data-url') };

          /**
           * Verify that we have the information for the media and url
           */
          if (!parameters.media || !parameters.url) {
              return false;
          }

          /**
           * Set default variables for the share window
           */
          let w = 800, h = 500, popup = true;

          /**
           * Attach a custom event to handle the sharing
           */
          component.addEventListener('click', () => {
              /**
               * Set some setting based on the media
               */
              switch (parameters.media) {
                  case 'X':
                      h = 300;
                  break;

                  case 'fancy':
                      w = 480;
                      h = 720;
                  break;

                  case 'google':
                      w = 500;
                  break;

                  case 'reddit':
                      popup = false;
                  break;

                  case 'skype':
                      w = 500;
                      h = 720;
                  break;
              }

              /**
               * Open the window for sharing
               */
              window.open(parameters.url, popup, 'width=' + w + ', height=' + h);
          });
      });
   }

   function toggleSocialShare(){
      /**
       * This is for the social share button
       * It toggles the visibility of the social share holder
       * and closes it when clicking outside of it
       */
        const shareBtn = document.querySelector('.share-btn');
        const shareHolder = document.querySelector('.social-share-holder');

        if (!shareBtn || !shareHolder) return;

        shareBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            shareHolder.classList.toggle('active');
        });

        document.addEventListener('click', function (event) {
            if (!shareHolder.contains(event.target) && !shareBtn.contains(event.target)) {
                shareHolder.classList.remove('active');
            }
        });
  }

  export {
    socialShare,
    toggleSocialShare
  }